




























































































































































import BankSlipForm from '@/components/forms/payment/BankSlipForm.vue';
import CreditCardForm from '@/components/forms/payment/CreditCardForm.vue';
import { PixForm, PixPayment } from '@/components/forms/payment/pixForm/index';
import LoadingPage from '@/components/LoadingPage.vue';
import PipelineMenuWrapper from '@/components/PipelineMenuWrapper.vue';
import { PaymentInfoTrackingModel } from '@/helpers/paymentInfoTracking';
import { formatNumberToCurrency } from '@/helpers/formatters';
import i18n from '@/i18n';
import { Button, Icon, Toast } from '@/components/ds';
import Vue from 'vue';
import { ONE_MINUTE, subtractTime, toDate } from '../helpers/date';
import { AnalyticsActions } from '../store/modules/analytics/actions';
import pipeline from '@/pipeline';
import Analytics from '@/helpers/analytics';
import { Course } from '@/store/modules/enrollment/state';

export default Vue.extend({
  components: {
    PipelineMenuWrapper,
    Button,
    Icon,
    CreditCardForm,
    BankSlipForm,
    PixForm,
    PixPayment,
    Toast,
    LoadingPage,
  },
  data() {
    return {
      paymentMethod: 'creditCard',
      isModalShown: false,
      isLoading: false,
      error: false,
      errorMessage: '',
      pixTimer: {
        timer: -1,
        timerClock: '',
        timerSetTimeout: null as NodeJS.Timeout | null,
      },
      pixTimerEnabled: false,
      intervalStatusPix: null as NodeJS.Timeout | null,
    };
  },
  computed: {
    showPixQrCode(): boolean {
      return this.$store.getters.showPixQrCode;
    },
    paymentTitle(): string {
      if (this.isFreeEnrollment) return i18n.t('payment.free.title');
      return this.showPixQrCode ? i18n.t('payment.form.pix.title') : i18n.t('payment.title');
    },
    isCreditCard(): boolean {
      return this.paymentMethod === 'creditCard';
    },
    isBankSlip(): boolean {
      return this.paymentMethod === 'bankSlip';
    },
    isPix(): boolean {
      return this.paymentMethod === 'pix';
    },
    currentPaymentMethod(): 'bankSlip' | 'creditCard' | 'pix' {
      return this.$store.getters.currentPaymentMethod;
    },
    isPixCodeExpired(): boolean {
      return this.$store.getters.isPixCodeExpired;
    },
    pixCode(): string {
      return this.$store.getters.pixData.payload || '';
    },
    sponsorName(): string {
      return this.$store.getters.personalDataFinancialSponsor?.fullName || '';
    },
    studentName(): string {
      return this.$store.getters.personalData?.fullName || '';
    },
    studentEmail(): string {
      return this.$store.getters.personalData?.email || '';
    },
    // Valor cru vindo do store: `undefined` enquanto não carregou (ou se a busca
    // falhou) e `0` para bolsa integral do ProUni. Os dois casos são diferentes na
    // tela, então nunca teste por truthiness aqui.
    rawPaymentValue(): number | undefined {
      return this.$store.getters.paymentValue;
    },
    paymentValue(): string {
      if (this.rawPaymentValue == null) return '';
      return formatNumberToCurrency(this.rawPaymentValue);
    },
    // O riscado é texto fixo do i18n (preço cheio), não cálculo. Com bolsa integral
    // ele fica ao lado do "R$ 0,00" e é justamente o que comunica o desconto.
    strikedPrice(): string {
      return this.rawPaymentValue == null ? '' : i18n.t('payment.infos.strikedPrice');
    },
    // Bolsa integral: não há o que cobrar. A etapa de pagamento continua existindo
    // (nada de pular tela ou transição nova na máquina), mas pedir cartão de quem
    // não deve nada é constrangedor e trava a conclusão da matrícula.
    isFreeEnrollment(): boolean {
      return this.rawPaymentValue === 0;
    },
    shouldShowPaymentMethods(): boolean {
      return !this.showPixQrCode && !this.isFreeEnrollment;
    },
    hasErrorVoucher(): boolean {
      return this.$store.getters.hasErrorVoucher;
    },
    partnerCode(): string {
      return this.$store.getters.partnerCode || '';
    },
    courseName(): string {
      return this.$store.getters.courseName || '';
    },
    paymentInfoTracking(): PaymentInfoTrackingModel {
      return new PaymentInfoTrackingModel(
        this.$store.getters.paymentValue,
        this.partnerCode,
        this.courseName,
      );
    },
    shouldRefreshQrcode(): boolean {
      return this.pixTimer.timer < 1;
    },
    enrollmentStatus(): string {
      return this.$store.getters.enrollmentStatus;
    },
    enrollmentId(): string {
      return this.$store.getters.enrollmentId;
    },
    course(): Course {
      return this.$store.getters.course;
    },
    isSuccess(): boolean {
      return this.enrollmentStatus === 'success';
    },
    shouldShowBankslip(): boolean {
      const { $router } = this;

      const SHOULD_DISABLE_BANKSLIP_THEME = 'b';
      const currentTheme = $router.currentRoute.query.theme;

      return currentTheme !== SHOULD_DISABLE_BANKSLIP_THEME;
    },
    studentAcademicRecord(): string {
      return this.$store.getters.backofficeStudentAcademicRecord;
    },
  },
  watch: {
    enrollmentStatus: {
      handler() {
        this.nextPipeLine();
      },
      immediate: true,
    },
    showPixQrCode: {
      handler(value) {
        if (value) {
          this.pixTimerEnabled = true;
        }
      },
      immediate: true,
    },
    pixTimerEnabled: {
      handler(value) {
        if (value) {
          this.pixTimer.timer = 10 * ONE_MINUTE;

          const timer = toDate(this.pixTimer.timer);

          this.pixTimer.timerClock = `${timer.getMinutes()}:${timer
            .getSeconds()
            .toString()
            .padStart(2, '0')}`;

          this.startPollingStatusPix();
        } else {
          this.stopPollingStatusPix();
          this.stopPollingSetTimeouPix();
        }
      },
    },
    'pixTimer.timer': {
      handler(value) {
        if (value >= 0) {
          this.pixTimer.timerSetTimeout = setTimeout(() => {
            if (this.pixTimer.timerSetTimeout)
              this.pixTimer.timer = subtractTime(value, { seconds: 1 });
          }, 1000);

          const diff = toDate(value);

          this.pixTimer.timerClock = `${diff.getMinutes()}:${diff
            .getSeconds()
            .toString()
            .padStart(2, '0')}`;
        }
        if (value <= 0) {
          this.pixTimerEnabled = false;
          this.stopPollingStatusPix();
          this.stopPollingSetTimeouPix();
        }
      },
      immediate: true,
    },
  },
  async created() {
    try {
      this.isLoading = true;
      await this.$store.dispatch('PULL_PAYMENT_VALUE');
      await this.$store.dispatch(AnalyticsActions.CHECKOUT_VIEWED);
      if (this.currentPaymentMethod === 'pix') await this.$store.dispatch('GET_PIX_STATUS');
      this.isLoading = false;
    } catch (err) {
      this.isLoading = false;
      this.errorMessage = i18n.t('personalData.genericError');
      this.error = true;
      setTimeout(() => {
        this.error = false;
      }, 5000);
      throw err;
    }
  },
  mounted() {
    if (this.partnerCode && this.hasErrorVoucher) {
      this.isLoading = false;
      this.showError();
    }

    if (this.currentPaymentMethod === 'pix') this.switchMethod('pix');
  },
  methods: {
    toggleModal() {
      this.isModalShown = !this.isModalShown;
    },
    async switchMethod(method: string) {
      this.paymentMethod = method;
      if (method === 'pix') {
        try {
          this.isLoading = true;
          await this.$store.dispatch('GET_PIX_STATUS');
          this.setShowQrcode(!this.isPixCodeExpired);
        } finally {
          this.isLoading = false;
        }
      }
    },
    showError() {
      this.errorMessage = i18n.t('personalData.errorAtVoucher');
      this.error = true;
      setTimeout(async () => {
        this.error = false;
      }, 5000);
    },
    setShowQrcode(showPixQrCode: boolean) {
      this.$store.commit('SET_SHOW_PIX_QRCODE', { showPixQrCode });
      this.pixTimerEnabled = showPixQrCode;
    },
    payOtherWay() {
      this.paymentMethod = 'creditCard';
      this.setShowQrcode(false);
    },
    enablePixQrCode() {
      this.setShowQrcode(!this.isPixCodeExpired);
    },
    async startPollingStatusPix() {
      this.stopPollingStatusPix();
      await this.$store.dispatch('GET_PIX_STATUS');

      this.intervalStatusPix = setInterval(async () => {
        await this.$store.dispatch('GET_PIX_STATUS');
      }, 30000);
    },
    stopPollingStatusPix() {
      if (this.intervalStatusPix) {
        clearInterval(this.intervalStatusPix);
        this.intervalStatusPix = null;
      }
    },
    stopPollingSetTimeouPix() {
      if (this.pixTimer.timerSetTimeout) {
        clearInterval(this.pixTimer.timerSetTimeout);
        this.pixTimer.timerSetTimeout = null;
      }
    },
    async refreshToken() {
      await this.$store.dispatch('GET_PIX_STATUS');
      this.pixTimerEnabled = true;
    },
    // Mesmo caminho do boleto (BankSlipForm.finishHandler): o `generateBankSlip` do
    // ug-enrollments já é zero-aware — com valor 0 ele cria o Payment como `paid` sem
    // chamar o serviço externo, então a matrícula volta `success` na hora. Sem download,
    // porque não existe boleto para baixar nesse caso.
    async confirmFreeEnrollment() {
      try {
        this.isLoading = true;
        await this.$store.dispatch('GENERATE_BANK_SLIP');
        await this.$store.dispatch('GET_ENROLLMENT');
        await this.$store.dispatch(AnalyticsActions.PAYMENT_SENT, {
          academicRecordId: this.studentAcademicRecord,
          paymentMethod: 'Gratuito',
          ...this.paymentInfoTracking,
        });

        pipeline.next({ status: this.enrollmentStatus });
      } catch (err) {
        this.errorMessage = i18n.t('personalData.genericError');
        this.error = true;
        setTimeout(() => {
          this.error = false;
        }, 5000);
        throw err;
      } finally {
        this.isLoading = false;
      }
    },
    nextPipeLine() {
      if (this.isSuccess) {
        if (this.isPix) {
          Analytics.trackEcommerceTransaction(this.enrollmentId, this.course, {
            academicRecordId: this.studentAcademicRecord,
            paymentMethod: 'Pix',
            email: this.studentEmail,
            ...this.paymentInfoTracking,
          });
        }
        pipeline.next({ status: this.enrollmentStatus });
      }
    },
  },
});
